import {cx} from "@emotion/css";

import {isNotUndefined} from "@/shared/FunctionCore";
import {classCombinerFromPrefix} from "@/app/pages/upik/resources/RenderIdentifier";
import {bottomContentParagraphs} from "@/app/pages/upik/resources/content";
import {BottomContentProps} from "@/app/pages/upik/resources/interfacesData";
import * as ContainerStyles from "@/app/pages/upik/styles/ContainerStyles.module.scss";
import React from "react";
import { bottomClickHereGermanURL, bottomClickHereUsURL } from "@/app/pages/upik/resources/constant";

const styles = ContainerStyles;

const classCombiner = classCombinerFromPrefix("a43bb12b864a3f8r");

export const BottomContent = ({
    bottomContentParaOneLocalized,
    bottomContentParaTwoLocalized,
    hereRedirectionLinkUrl,
    language,
    isPrivatePage
}: BottomContentProps): JSX.Element => {
    
    let paraOneHtmlString = isNotUndefined(bottomContentParaOneLocalized) ?
        bottomContentParaOneLocalized : bottomContentParagraphs.en.public.paraOne;

    const paraTwoHtmlString = isNotUndefined(bottomContentParaTwoLocalized) ?
        bottomContentParaTwoLocalized : bottomContentParagraphs.en.paraTwo;
    
    if (isNotUndefined(hereRedirectionLinkUrl)) {
        let getURL = isPrivatePage === true ? (language === 'de' ? bottomClickHereUsURL: bottomClickHereGermanURL) : hereRedirectionLinkUrl;
        paraOneHtmlString = paraOneHtmlString.replace("href='#'", `href=${getURL}`);
    }

    return (
        <div className={cx(classCombiner(styles, "upikBottomContentContainer"))}>
            <p
                className={cx(classCombiner(styles, "bottomMainContent"))}
                dangerouslySetInnerHTML={{"__html": paraOneHtmlString}}
            />

            <p
                dangerouslySetInnerHTML={{"__html": paraTwoHtmlString}}
            />
        </div>
    );
};
